export default __webpack_public_path__ + "static/media/BoardType.de2517e4.csv";